import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ user }) => {
  const menuItems = [
    { path: '/users', label: '👥 Users', adminOnly: true },
    { path: '/drivers', label: '🚗 Drivers', adminOnly: false },
    { path: '/trucks', label: '🚚 Trucks', adminOnly: false },
    { path: '/shippers', label: '📦 Shippers', adminOnly: false },
    { path: '/carriers', label: '🚛 Carriers', adminOnly: false },
    { path: '/consignees', label: '📍 Consignees', adminOnly: false },
    { path: '/freight', label: '📋 Freight', adminOnly: false },
    { path: '/freight/import', label: '📥 Import PDF', adminOnly: true },
    { path: '/manifests', label: '📄 Manifests', adminOnly: false },
    { path: '/manifest-templates', label: '🧾 Manifest Templates', adminOnly: true },
    { path: '/depots', label: '🏭 Depots', adminOnly: true },
    { path: '/route-planner', label: '🗺️ Route Planner', adminOnly: true },
    { path: '/ops', label: '📡 Operations', adminOnly: true },
    { path: '/warehouse-rows', label: '🏬 Warehouse Rows', adminOnly: false },
    { path: '/warehouse-bins', label: '📦 Warehouse Bins', adminOnly: false },
    { path: '/inventory-items', label: '📦 Inventory Items', adminOnly: false },
    { path: '/inventory-low-stock', label: '⚠️ Low stock', adminOnly: false },
    { path: '/inventory-transfers', label: '🧾 Inventory Transfers', adminOnly: true },
    { path: '/hs-codes', label: '📑 HS / HTS codes', adminOnly: true },
  ];

  const filteredItems = menuItems.filter(item => 
    !item.adminOnly || (user && user.role === 'admin')
  );

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {filteredItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `sidebar-link ${isActive ? 'active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;


